import { toast, ToastOptions } from 'react-toastify';

type ToastVariant = 'success' | 'error' | 'warning' | 'info';

const VARIANT_CLASSES: Record<ToastVariant, string> = {
  success: 'border-success-200',
  error: 'border-danger-200',
  warning: 'border-warning-200',
  info: 'border-primary-200',
};

const DEFAULT_OPTIONS: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const showToast = (message: string, variant: ToastVariant = 'info', duration: number = 5000) => {
  toast[variant](
    <span className="text-sm font-medium leading-5 text-neutral-600">{message}</span>,
    {
      ...DEFAULT_OPTIONS,
      autoClose: duration,
      className: `bg-surface border rounded-md shadow-lg p-2 pr-8 ${VARIANT_CLASSES[variant]}`,
    },
  );
};

const toastApi = {
  showToast,
  success: (message: string, duration?: number) => showToast(message, 'success', duration),
  error: (message: string, duration?: number) => showToast(message, 'error', duration),
  warning: (message: string, duration?: number) => showToast(message, 'warning', duration),
  info: (message: string, duration?: number) => showToast(message, 'info', duration),
  dismiss: (id: string) => toast.dismiss(id),
  dismissAll: () => toast.dismiss(),
};

export const useToast = () => toastApi;

export default useToast;
